const crypto = window.crypto || window.msCrypto;

const generateRandomId = () => {
  const array = new Uint32Array(1);
  return crypto.getRandomValues(array)?.[0];
};

export default generateRandomId;
